/** Shared layout for dashboard sliding-window cards. */

export const DASHBOARD_WINDOW_SIZE = 3;

/**
 * Fixed row height so sliding between items doesn't resize the card
 * (and the whole items-stretch row). Truncate content instead of growing.
 */
export const DASHBOARD_WINDOW_ROW =
  'h-[4.75rem] min-h-[4.75rem] max-h-[4.75rem] box-border';

/** List grows with visible count (1–3). No forced empty slots. */
export const DASHBOARD_WINDOW_LIST = 'space-y-3';
